<template>
  <div id="app">
    <h1>Le Défi solo de TT</h1>
    <div>
      <div class="filters">
        <!-- Type de classement -->
        <div class="type-classement">
          <b-form-radio-group
            id="radio-group-1"
            v-model="classementSelection"
            :options="classementOptions"
            name="radio-options"
            v-on:change="typeSelected"
          ></b-form-radio-group>
        </div>
        <!-- Année -->
        <div class="annee" v-if="classementSelection === 'year'">
          <b-form-checkbox-group
            id="checkbox-1"
            v-model="yearsSelection"
            name="year"
            :options="yearsOptions"
            v-on:change="yearSelected"
          ></b-form-checkbox-group>
        </div>
        <!-- Mois -->
        <div class="month"  v-if="classementSelection === 'month'">
          par mois
        </div>
        <!-- Intervalle -->
        <div class="intervalle"  v-if="classementSelection === 'interval'">
          Mois de début (inclus): <vue-monthly-picker
            v-model="fromMonth"
            dateFormat="YYYY-MM"
            v-on:selected="intervalChangeFrom"
            :min="minMonth"
            :max="toMonth">
          </vue-monthly-picker>
          Mois de fin (inclus): <vue-monthly-picker
            v-model="toMonth"
            dateFormat="YYYY-MM"
            v-on:selected="intervalChangeTo"
            :min="fromMonth"
            :max="maxMonth">
          </vue-monthly-picker>
        </div>
      </div>
      <b-table striped hover :items="data" :fields="fields"></b-table>
    </div>
  </div>
</template>

<script>
import json2018 from '@/assets/ttsolo_2018.json'
import json2019 from '@/assets/ttsolo_2019.json'
import json2020 from '@/assets/ttsolo_2020.json'
import json2021 from '@/assets/ttsolo_2021.json'
import json2022 from '@/assets/ttsolo_2022.json'
import alasql from 'alasql'
import VueMonthlyPicker from 'vue-monthly-picker'
import moment from 'moment'

export default {
  name: 'App',
  components: {
    VueMonthlyPicker
  },
  data: function() {
    return {
      json2018: json2018[0].json,
      json2019: json2019[0].json,
      json2020: json2020[0].json,
      json2021: json2021[0].json,
      json2022: json2022[0].json,
      json: [],
      minMonth: new moment('2018-01-01'),
      maxMonth: new moment(),
      fromMonth: new moment('2022-01-01'),
      toMonth: new moment('2022-04-01'),
      classementOptions: [
        { text: 'Par Année', value: 'year' },
        /*{ text: 'Par Mois', value: 'month' },*/
        { text: 'Par Intervalle de dates', value: 'interval' },
      ],
      classementSelection: 'year',
      yearsOptions: [
        { text: '2018', value: '2018' },
        { text: '2019', value: '2019' },
        { text: '2020', value: '2020' },
        { text: '2021', value: '2021' },
        { text: '2022', value: '2022' },
      ],
      yearsSelection: [],
      data: [],
      fields: [
        {
          key: 'jeu',
          label: 'Jeu',
          sortable: true
        },
        {
          key: 'total',
          label: 'Nombre de parties jouées',
          sortable: true
        },
        {
          key: 'nbJoueur',
          label: 'Nombre de joueur différent',
          sortable: true
        }
      ],
      request: `SELECT jeu, SUM(nbPartie) as total, COUNT(DISTINCT joueur) AS nbJoueur
        FROM ttsolo.partie 
        WHERE 1=1
        ::
        GROUP BY jeu
        ORDER BY SUM(nbPartie) DESC`
    }
  },
  mounted: function() {
    this.json = this.json2018
      .concat(this.json2019)
      .concat(this.json2020)
      .concat(this.json2021)
      .concat(this.json2022)
    // console.log(this.json)
    var mybase = new alasql.Database('ttsolo');
    mybase.exec('CREATE TABLE IF NOT EXISTS partie (datePartie STRING, id INT, jeu STRING, joueur STRING, nbPartie INT)');
    // console.log(alasql.databases, mybase);
    const insertString = 'INSERT INTO ttsolo.partie (?, ?, ?, ?, ?)'
    const insertRequest = alasql.compile(insertString)
    this.json.forEach(partie => {
      const partieData = [
        partie.date,
        partie.id,
        partie.jeu,
        partie.joueur,
        partie.nbPartie
      ]
      insertRequest(partieData)
    })
    const updatedRequest = this.request.replaceAll('::', '')
    this.data = alasql(updatedRequest);
    // console.log(this.data);
  },
  methods: {
    intervalChangeFrom: function (selected) {
      this.fromMonth = selected

      const whereFrom = ' AND SUBSTRING(datePartie, 1, 7) >= \'' + this.fromMonth.format('YYYY-MM') + '\'';
      const whereTo = ' AND SUBSTRING(datePartie, 1, 7) <= \'' + this.toMonth.format('YYYY-MM') + '\''
      const updatedRequest = this.request.replaceAll('::', whereFrom + whereTo)
      this.data = alasql(updatedRequest);
    },
    intervalChangeTo: function (selected) {
      this.toMonth = selected

      const whereFrom = ' AND SUBSTRING(datePartie, 1, 7) >= \'' + this.fromMonth.format('YYYY-MM') + '\'';
      const whereTo = ' AND SUBSTRING(datePartie, 1, 7) <= \'' + this.toMonth.format('YYYY-MM') + '\''
      const updatedRequest = this.request.replaceAll('::', whereFrom + whereTo)
      this.data = alasql(updatedRequest);
    },
    typeSelected: function () {
      const whereFrom = ' AND SUBSTRING(datePartie, 1, 7) >= \'' + this.fromMonth.format('YYYY-MM') + '\'';
      const whereTo = ' AND SUBSTRING(datePartie, 1, 7) <= \'' + this.toMonth.format('YYYY-MM') + '\''
      const updatedRequest = this.request.replaceAll('::', whereFrom + whereTo)
      this.data = alasql(updatedRequest);
    },
    yearSelected: function () {
      // console.log('yearSelected', this.yearsSelection)
      let req = ''
      if (this.yearsSelection.length > 0) {
        req = 'AND ('
        this.yearsSelection.forEach(year => {
          req += 'SUBSTRING(datePartie,1,4) = \'' + year + '\' OR '
        })
        req = req.substring(0, req.length - 3)
        req += ')'
      }
      // console.log('filtered', req)
      const updatedRequest = this.request.replaceAll('::', req)
      this.data = alasql(updatedRequest);
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
  padding-left: 100px;
  padding-right: 100px;
}

.annee {
  margin-bottom: 10px;
}

.intervalle {
  margin-bottom: 10px;
  padding-left: 100px;
  padding-right: 100px;
}

.type-classement {
  margin-bottom: 10px;
}
</style>
